<template>
  <KModal @close="closeModal" ariaModalLabel="Error Modal">
    <template #content>
      <div :aria-describedby="$id('errorModalDescription')" :aria-labelledby="$id('errorModalTitle')" class="flex flex-col items-center justify-center k-modal--error">
        <KIcon name="pencil" class="mt-10 w-24 h-auto" />
        <h2 :id="$id('errorModalTitle')" class="modal-header text-center">
          {{ content.errorTitle }}
        </h2>
        <div :id="$id('errorModalDescription')" class="modal-text-content text-center" v-dompurify-html="content.errorText"/>
        <KButton
          :aria-label="content.errorTryAgain"
          theme="primary"
          class="w-100 mt-10 mb-2 md:mt-8 flex justify-center items-center"
          @click="reloadPage"
          >{{ content.errorTryAgain }}
        </KButton>
        <KButton
          :aria-label="content.errorClose"
          @click="closeModal"
          theme="primary"
          class="pt-4"
          textOnly
        >
         {{ content.errorClose }}
        </KButton>
      </div>
    </template>
  </KModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { KIcon, KButton, KModal } from '@/components'
import { useGlobal } from '@/store'
import { Error } from '@/model'

export default defineComponent({
  name: 'ErrorModal',
  components: { KIcon, KButton, KModal },
  props: {
    content: {
      type: Error,
      required: false,
      default: Error.default()
    }
  },
  setup () {
    const closeModal = () => {
      const global = useGlobal()
      global.$patch({ isErrorModalOpened: false })
    }
    const reloadPage = () => {
      window.location.reload()
    }
    return {
      closeModal,
      reloadPage
    }
  }
})
</script>

<style scoped>
.k-modal--error {
  width: calc(100vw - theme("spacing.16"));
  margin-left: auto;
  margin-right: auto;
  min-height: 356px; /* all modals have this height on mobile */
}

@screen md {
  .k-modal--error {
    width: calc(theme("width.modal-desktop") - 2 * theme("padding.4"));
  }
}
</style>
